// module.exports = {
//   google: {
//     API_KEY: "",
//     CLIENT_ID: "",
//     SECRET: "",
//   },
//   facebook: {
//     APP_ID: "",
//   },
//   api: {
//     API_URL: process.env.REACT_APP_API_URL
//   }
// };


const getApiUrl = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'dev':
      return process.env.REACT_APP_API_DEV_URL
    case 'local':
      return process.env.REACT_APP_API_LOCAL_URL;
    default:
      return process.env.REACT_APP_API_URL;
  }
};

export const API_URL = getApiUrl();